import { Route, Switch } from "react-router-dom";
import GetResults from "./Pages/GetResults";
// write a react component here

const CompanySpecificSummer = () => {
	return (
		<div>
			<Switch>
				<Route path="/css/get-results">
					<GetResults />
				</Route>
			</Switch>
		</div>
	);
};

export default CompanySpecificSummer;
